<template>
  <b-row>
    <b-col style="height: 120pt;">
      <md-progress-bar md-mode="indeterminate" v-if="loading"></md-progress-bar>
      <div v-else>
        <b-row>
          <b-col>
            <md-checkbox
              v-model="lessorSignature"
              class="md-primary"
              :disabled="readonlyLocal"
            >{{lessorSignatureText}}</md-checkbox>
            <md-checkbox
              v-model="lesseeSignature"
              class="md-primary"
              :disabled="readonlyLocal"
            >{{lesseeSignatureText}}</md-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="!readonly">
          <b-col v-if="readonlyLocal">
            <moow-button :type="['dark', 'outlined']" btnText="Edit" @mClick="readonlyLocal=false" />
          </b-col>
          <b-col v-else>
            <moow-button
              :type="['dark', 'outlined', 'flat']"
              btnText="Cancel"
              @mClick="cancelSignatures"
            />
            <moow-button :type="['light']" btnText="Save" @mClick="saveSignatures" />
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>
<script>
import {
  getDealSignatures,
  upsertDealSignatures,
} from "@/platform/contracts/services/contractService.js";

export default {
  props: {
    readonly: {
      type: Boolean,
      default: true,
    },
    dealId: {
      type: String,
      required: true,
    },
    dealSnapshotId: {
      type: String,
      required: false,
    },
    accountId: {
      type: String,
      required: false,
    },
  },
  data: function () {
    return {
      readonlyLocal: true, // this is used to toggle edit
      loading: true,
      lesseeSignature: false,
      lessorSignature: false,
      lesseeSignature_prev: undefined,
      lessorSignature_prev: undefined,
    };
  },
  watch: {
    dealId: function (val, oldVal) {
      if (val && val != oldVal)
        this.getSignatures(this.dealId, this.dealSnapshotId);
    },
    dealSnapshotId: function (val, oldVal) {
      if (val && val != oldVal)
        this.getSignatures(this.dealId, this.dealSnapshotId);
    },
  },
  filters: {},
  computed: {
    lesseeSignatureText() {
      if (this.lesseeSignature) return "Tenant signature";
      else return "Tenant signature";
    },
    lessorSignatureText() {
      if (this.lessorSignature) return "Landlord signature";
      else return "Landlord signature";
    },
  },
  created() {
    if (this.dealId) this.getSignatures(this.dealId, this.dealSnapshotId);
  },
  methods: {
    cancelSignatures() {
      this.readonlyLocal = true;
      this.restorePrevSignatures();
    },
    restorePrevSignatures() {
      this.lesseeSignature = this.lesseeSignature_prev;
      this.lessorSignature = this.lessorSignature_prev;
    },
    setPreviousSignatures({ lessor, lessee }) {
      this.lesseeSignature_prev = lessee;
      this.lessorSignature_prev = lessor;
    },
    saveSignatures() {
      if (this.dealId) {
        this.loading = true;
        this.readonlyLocal = true;
        upsertDealSignatures({
          dealId: this.dealId,
          dealSnapshotId: this.dealSnapshotId,
          accountId: this.accountId,
          lessee: this.lesseeSignature,
          lessor: this.lessorSignature,
        })
          .then((result) => {
            this.$emit("emitSignaturesUpdated", {
              lessee: this.lesseeSignature,
              lessor: this.lessorSignature,
            });
            this.setPreviousSignatures({
              lessee: this.lesseeSignature,
              lessor: this.lessorSignature,
            });
          })
          .catch((err) => {
            this.$emit("emitNotifyMessage", "Cannot update signatures");
            this.restorePrevSignatures();
          })
          .finally((f) => {
            this.loading = false;
          });
      } else {
        this.$emit("emitNotifyMessage", "Cannot update signatures");
      }
    },
    getSignatures(dealId, dealSnapshotId) {
      this.toggleLoading(true);
      getDealSignatures({ dealId, dealSnapshotId })
        .then((response) => {
          if (!response) {
            this.lesseeSignature = false;
            this.lessorSignature = false;
            return;
          }
          if (
            response.signatures &&
            response.signatures.lessee &&
            response.signatures.lessee.timestamp
          )
            this.lesseeSignature = true;

          if (
            response.signatures &&
            response.signatures.lessor &&
            response.signatures.lessor.timestamp
          )
            this.lessorSignature = true;
        })
        .catch((err) => {
          this.lessorSignature = false;
          this.lesseeSignature = false;
          this.$emit("emitNotifyMessage", "Cannot get signatures");
        })
        .finally((f) => {
          this.setPreviousSignatures({
            lessee: this.lesseeSignature,
            lessor: this.lessorSignature,
          });
          this.$emit("emitSignaturesUpdated", {
            lessee: this.lesseeSignature,
            lessor: this.lessorSignature,
          });
          this.toggleLoading(false);
        });
    },
    toggleLoading(isLoading) {
      this.loading = isLoading;
      this.$emit("emitToggleLoading", isLoading);
    },
    getCurrentSignatures() {
      return {
        lessor: this.lessorSignature,
        lessee: this.lesseeSignature,
      };
    },
  },
};
</script>
<style scoped>
@import "../../assets/styles/global.css";
@import "../../assets/styles/listing-preview.css";
</style>



// WEBPACK FOOTER //
// src/components/contracts/contractSignatures.vue